import { Link } from '@design-system/link';
import classNames from 'classnames';
import React, { FC } from 'react';

import { CartIconProps } from './models';

export const CartIcon: FC<CartIconProps> = ({
  ariaLabel,
  href,
  LinkComponent = Link,
  itemsQuantity,
}) => (
  <LinkComponent
    className={classNames('cds-shopping-cart-icon', {
      'cds-shopping-cart-icon--no-items': itemsQuantity === 0,
    })}
    variant="subtle-icon"
    size="small"
    href={href}
    iconSuffix={{ props: { icon: 'shoppingCart' } }}
    aria-label={ariaLabel}
  >
    {itemsQuantity}
  </LinkComponent>
);
